"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireWildcard(require("react"));
var _Title = _interopRequireDefault(require("../Title"));
var _InterFaceSvg = _interopRequireDefault(require("../Business/InterFaceSvg"));
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
function SceneTabsRelevance(props) {
  var _a = props || {},
    flexTitle = _a.flexTitle,
    style = _a.style,
    _b = _a.configuration,
    configuration = _b === void 0 ? [] : _b;
  // const _configuration_title: any[] = [];
  var _c = (0, _react.useState)(0),
    stindex = _c[0],
    setStindex = _c[1];
  // configuration.forEach((item?: any) => {
  //   const { title, list } = item || {};
  //   // const { description } = list || {};
  //   _configuration_title.push({
  //     title,
  //     list,
  //     // description,
  //   });
  // });
  var listMapLen = configuration.length;
  (0, _react.useEffect)(function () {
    var widthWindows = document.documentElement.offsetWidth || document.body.offsetWidth;
    if (listMapLen > 1 && widthWindows > 768) {
      setStindex(0);
    }
  }, []);
  var accordionData = configuration ? configuration.map(function (item, index) {
    var title = (item || {}).title;
    var list = (item || {}).list;
    list = list.map(function (list_item) {
      var _a = list_item || {},
        // title,
        imageUrl = _a.imageUrl,
        product = _a.product,
        related = _a.related,
        description = _a.description,
        article = _a.article,
        filedVideoBg = _a.filedVideoBg,
        filedVideoList = _a.filedVideoList;
      return {
        title: title,
        tabTitle: title,
        description: description,
        content: article,
        filedVideoBg: filedVideoBg,
        filedVideoList: filedVideoList,
        imageSrc: imageUrl,
        product: product,
        related: related
      };
    });
    return {
      key: index + 1,
      title: title,
      list: list
    };
  }) : [];
  var rightIndex = 0;
  var leftIndex = 0;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("section", {
    style: (0, _typeof2["default"])(style) === 'object' ? style : {},
    className: 'relevance-flex-default-scene-tabs-container'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-scene-tabs-container__children'
  }, /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    title: flexTitle
  }), /*#__PURE__*/_react["default"].createElement("section", {
    className: 'scene-tabs-container'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'scene-tabs-container-left'
  }, configuration.map(function (_item, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: 'scene-tabs-container-left__list',
      key: index
    }, /*#__PURE__*/_react["default"].createElement("h4", {
      className: 'scene-tabs-h4'
    }, _item.title), /*#__PURE__*/_react["default"].createElement("div", null, _item.list.map(function (items, i) {
      var lIndex = leftIndex;
      leftIndex += 1;
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: i,
        className: (0, _classnames["default"])('relevance-scene-tabs-description', {
          'relevance-scene-tabs-h4--active': lIndex === stindex
        }),
        "report-event": "click_sceneTabsRelevance_tab",
        "report-ext1": index,
        "report-ext2": i,
        "report-ext3": items.description || '',
        onClick: function onClick() {
          setStindex(lIndex);
        }
      }, items.description);
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'scene-tabs-process'
    }));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'scene-tabs-container-right'
  }, configuration.map(function (item, _index) {
    var list = (item || {}).list;
    return list.map(function (list_items, index_c) {
      var _a = list_items || {},
        description = _a.description,
        imageUrl = _a.imageUrl,
        article = _a.article,
        related = _a.related,
        product = _a.product;
      var rIndex = rightIndex;
      rightIndex += 1;
      return /*#__PURE__*/_react["default"].createElement("section", {
        key: index_c,
        className: (0, _classnames["default"])('scene-tabs-container-right__section', {
          'scene-tabs-container-right__section-show': rIndex === stindex
        })
      }, /*#__PURE__*/_react["default"].createElement("h4", {
        className: 'scene-tabs-h4 scene-tabs-h4-right'
      }, description), imageUrl ? (/*#__PURE__*/_react["default"].createElement(PictureComponent, {
        style: {
          width: '10px',
          borderRadius: '4px',
          margin: '16px auto 24px',
          display: 'block'
        },
        imageSrc: imageUrl,
        seneList: listMapLen
      })) : null, article ? (/*#__PURE__*/_react["default"].createElement("article", {
        dangerouslySetInnerHTML: {
          __html: article
        }
      })) : null, /*#__PURE__*/_react["default"].createElement("h5", {
        className: 'scene-tabs-h5'
      }, related), /*#__PURE__*/_react["default"].createElement("div", {
        className: 'scene-ul-container-r'
      }, product ? product.map(function (items, i) {
        var _a = items || {},
          title = _a.title,
          logo = _a.logo,
          logoHov = _a.logoHov,
          url = _a.url;
        var logoUrl = (0, _utils.fomateFileData)(logo).url;
        var logoHovUrl = (0, _utils.fomateFileData)(logoHov).url;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: 'scene-ul-container-r-div',
          key: i
        }, url ? (/*#__PURE__*/_react["default"].createElement("a", {
          href: url,
          "report-event": "click_sceneTabsRelevance_product_href",
          "report-ext1": i,
          "report-ext2": title || '',
          "report-ext3": url || ''
        }, /*#__PURE__*/_react["default"].createElement(_InterFaceSvg["default"], {
          enterUrl: logoUrl || logoHovUrl,
          leaveUrl: logoHovUrl || logoUrl
        }), title)) : (/*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_InterFaceSvg["default"], {
          enterUrl: logoUrl || logoHovUrl,
          leaveUrl: logoHovUrl || logoUrl
        }), title)));
      }) : null));
    });
  }))))), /*#__PURE__*/_react["default"].createElement(FlexAccordion, {
    style: style,
    configuration: accordionData,
    flexTitle: flexTitle
  }));
}
var _default = exports["default"] = SceneTabsRelevance;
function PictureComponent(props) {
  var imageSrc = props.imageSrc,
    style = props.style,
    _a = props.seneList,
    seneList = _a === void 0 ? {} : _a;
  var _b = (0, _utils.fomateFileData)(imageSrc),
    url = _b.url,
    _c = _b.alt,
    alt = _c === void 0 ? '' : _c;
  var _d = (0, _react.useState)({}),
    styles = _d[0],
    setStyls = _d[1];
  var _e = (0, _react.useState)({}),
    divStyle = _e[0],
    setDivStyle = _e[1];
  (0, _react.useEffect)(function () {
    var imgLoad = new Image();
    if (url) {
      imgLoad.src = url;
    }
    imgLoad.onload = function () {
      var collectStyles = {};
      var divStyle = {};
      if (imgLoad.width / imgLoad.height < 1.8) {
        var imgheight = void 0;
        if (seneList <= 5) {
          imgheight = 345;
        } else if (5 < seneList && seneList < 9) {
          imgheight = 460;
        } else {
          imgheight = 517;
        }
        collectStyles = {
          height: imgheight + "px",
          width: 'auto'
        };
        divStyle = {
          textAlign: 'center'
        };
      } else {
        collectStyles = {
          width: '100%',
          height: 'auto'
        };
      }
      setDivStyle(divStyle);
      setStyls(collectStyles);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: __assign({}, divStyle)
  }, /*#__PURE__*/_react["default"].createElement("img", {
    style: __assign(__assign({}, style), styles),
    src: url,
    alt: alt
  }));
}
function FlexAccordion(props) {
  var configuration = props.configuration,
    flexTitle = props.flexTitle,
    style = props.style;
  var _a = (0, _react.useState)(1),
    saveKey = _a[0],
    setSaveKey = _a[1];
  var childrenNodes = {};
  var getHeightVal = (0, _react.useRef)({});
  (0, _react.useEffect)(function () {
    setTimeout(function () {
      if (getHeightVal) {
        childrenNodes = getHeightVal.current.childNodes;
        // todo optimize
        // 12 初始状态下少12 offsetHeight
        // 24 距离底部距离
        for (var i = 0; i < childrenNodes.length; i++) {
          getHeightVal.current.childNodes[i].childNodes[0].lastChild.style.height = getHeightVal.current.childNodes[i].childNodes[0].lastChild.offsetHeight + "px";
          // console.log(getHeightVal.current.childNodes[i].childNodes[0].lastChild.childNodes);
        }
      }
    }, 1000);
  }, []);
  var checkTabsStatus = function checkTabsStatus(key) {
    var childrenNodesEle = getHeightVal;
    var _loop_1 = function _loop_1(i) {
      // 查询到指定要获取高度
      var transformClass = childrenNodesEle.current.childNodes[i].childNodes[0];
      if (i === Number(key) - 1) {
        if (transformClass.className.indexOf('am-accordion-item-leave') > -1) {
          setTimeout(function () {
            var collectHeight = 0;
            for (var i_1 = 0; i_1 < transformClass.childNodes[1].childNodes.length; i_1++) {
              collectHeight += transformClass.childNodes[1].childNodes[i_1].offsetHeight;
            }
            // 24 距离底部距离
            transformClass.lastChild.style.height = collectHeight - 25 + "px";
            // debugger
            // console.log(collectHeight,transformClass.lastChild);
          });
          transformClass.className = 'am-accordion-item';
        } else {
          transformClass.lastChild.style.height = '0';
          transformClass.className = 'am-accordion-item-leave';
        }
      } else {
        transformClass.lastChild.style.height = '0';
        transformClass.className = 'am-accordion-item-leave';
      }
    };
    // todo optimize
    for (var i = 0; i < childrenNodesEle.current.childNodes.length; i++) {
      _loop_1(i);
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'relevance-flex-scene-accordion',
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    title: flexTitle
  }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "am-accordion my-accordion"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    ref: getHeightVal
  }, configuration.map(function (item, i) {
    var _a = item,
      list = _a.list,
      title = _a.title,
      // description,
      // tabTitle,
      key = _a.key;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: 'am-accordion-tab',
      key: i
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])({
        'am-accordion-item': i === 0,
        'am-accordion-item-leave': i !== 0
      }),
      onClick: function onClick() {
        checkTabsStatus(key);
        if (key === saveKey) {
          setSaveKey(0);
        } else {
          setSaveKey(key);
        }
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "am-accordion-title",
      role: "button",
      "aria-expanded": "false"
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'am-accordion-title__scene-tabs-h4'
    }, title), /*#__PURE__*/_react["default"].createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      className: "design-iconfont d-icon"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      transform: "rotate(-180 12.25 12.25)",
      d: "M12.5 10.8035221L17.6191093 16 19 14.5982389 12.5 8 6 14.5982389 7.3808907 16z",
      fillRule: "evenodd"
    })))), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'am-accordion-container'
    }, list.map(function (list_item, list_index) {
      var description = list_item.description,
        // tabTitle,
        // key,
        related = list_item.related,
        product = list_item.product,
        content = list_item.content,
        // filedVideoBg,
        // filedVideoList,
        imageSrc = list_item.imageSrc;
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: list_index,
        style: {
          height: 'fit-content'
        }
      }, saveKey - 1 === i ? (/*#__PURE__*/_react["default"].createElement("div", {
        className: 'am-accordion-title__scene-tabs-description'
      }, description)) : null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "am-accordion-content"
      }, /*#__PURE__*/_react["default"].createElement(PictureComponent
      // style={{
      //   maxWidth: '24px',
      //   maxHeight: '24px',
      //   width: '10px',
      // }}
      , {
        // style={{
        //   maxWidth: '24px',
        //   maxHeight: '24px',
        //   width: '10px',
        // }}
        imageSrc: imageSrc
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: 'am-accordion-content__article',
        dangerouslySetInnerHTML: {
          __html: content
        }
      }), /*#__PURE__*/_react["default"].createElement("h5", {
        className: 'scene-tabs-h5',
        style: {
          marginTop: '24px'
        }
      }, related), /*#__PURE__*/_react["default"].createElement("div", {
        className: 'scene-ul-container-r'
      }, product ? product.map(function (items, i) {
        var _a = items || {},
          title = _a.title,
          logo = _a.logo,
          logoHov = _a.logoHov,
          url = _a.url;
        var logoUrl = (0, _utils.fomateFileData)(logo).url;
        var logoHovUrl = (0, _utils.fomateFileData)(logoHov).url;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: 'scene-ul-container-r-div',
          key: i
        }, url ? (/*#__PURE__*/_react["default"].createElement("a", {
          href: url
        }, /*#__PURE__*/_react["default"].createElement(_InterFaceSvg["default"], {
          enterUrl: logoUrl || logoHovUrl,
          leaveUrl: logoHovUrl || logoUrl
        }), title)) : (/*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_InterFaceSvg["default"], {
          enterUrl: logoUrl || logoHovUrl,
          leaveUrl: logoHovUrl || logoUrl
        }), title)));
      }) : null), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          height: '1px',
          margin: '24px 0',
          background: ' rgba(0, 0, 0, 0.1)'
        }
      })));
    }))));
  }))))));
}